import { createContext, memo, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { excludeRoute, session } from '../helpers/helpers';
import mainRoutes from '../helpers/mainRoutes';
import { apiInstance } from '../utils/api';

export const AuthContext = createContext();

const ROUTES = {
  USER: new URL(`${process.env.REACT_APP_API_URL}/api/users/me?populate=*`),
};

const AuthProvider = ({ children, history }) => {
  const [user, setUser] = useState(null);
  const [contactStores, setContactStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = session.get('token');
  const [currentContactStore, setCurrentContactStore] = useState({});

  const isSigninPages = excludeRoute.includes(history.location.pathname);
  const isHomePage = history.location.pathname === '/' && !token;
  const mainRoutesPatnames = mainRoutes.map(({ path }) => path).includes(history.location.pathname);

  // Запрос за текущим пользователем
  useEffect(() => {
    if (token) {
      apiInstance(ROUTES.USER, 'GET', null)
        .then((fetchedUser) => {
          setUser(fetchedUser);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [token]);

  // НЕ делаем запрос за контактными магазинами в AuthContext
  // Это будет делать useContactStore
  useEffect(() => {
    const userContactStores = user?.contactStores;
    if (userContactStores && userContactStores.length > 0) {
      // НЕ устанавливаем currentContactStore здесь - это будет делать useContactStore
      // с полными объединенными данными
    } else {
      setContactStores([]);
      setCurrentContactStore({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // Простое обновление текущего контактного магазина
  const updateCurrentContactStore = (store) => {
    setCurrentContactStore(store || {});
  };

  useEffect(() => {
    if (isSigninPages || isHomePage || !mainRoutesPatnames) {
      setLoading(false);
    }
  }, [user, history, isSigninPages, isHomePage, mainRoutesPatnames]);

  const [isStoreSelectDisabled, setIsStoreSelectDisabled] = useState(false);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        loading,
        setLoading,
        token,
        setCurrentContactStore: (store) => {
          updateCurrentContactStore(store);
        },
        currentContactStore,
        contactStores,
        setContactStores,
        isStoreSelectDisabled,
        setIsStoreSelectDisabled,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default withRouter(memo(AuthProvider));
